import React, { FunctionComponent, PropsWithChildren } from 'react';
import classnames from 'classnames';

import { Button as ButtonComponent, ButtonProps as ButtonComponentProps, useBreakpoint } from '@savebetter/components';

import { useBankProducts } from '../context/BankProductsContext';
import { replaceCustomVars } from '../utils/replaceCustomVar';

import { Section } from './Section';

type Justify = 'justify-center' | 'justify-left' | 'justify-right';

type ButtonProps = {
  blok: ButtonComponentProps & {
    text: string;
    hasBackground?: boolean;
    hasPaddingBottom?: boolean;
    hasPaddingTop?: boolean;
    justify?: Justify;
    backgroundColor?: string;
    isSecondaryColor?: boolean;
  };
};

const getButtonJustify = (justify: Justify = 'justify-center'): string => `flex ${justify}`;

export const Button: FunctionComponent<PropsWithChildren<ButtonProps>> = ({ blok }) => {
  const { contextProducts } = useBankProducts();
  const breakpoint = useBreakpoint();
  const { hasBackground, hasPaddingTop, hasPaddingBottom, text, justify, backgroundColor = '', ...restProps } = blok;

  return (
    <Section
      width={breakpoint}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
      hasBackground={hasBackground}
      className={classnames({
        [backgroundColor]: !hasBackground
      })}
    >
      <div className={getButtonJustify(justify)}>
        <ButtonComponent {...restProps}>{replaceCustomVars(text, contextProducts)}</ButtonComponent>
      </div>
    </Section>
  );
};
